import type { Sort } from '~/contracts/SearchRepositoryContract'
import { getQueryString } from '~/lib/filters'
import type { FilterGroup } from '~/types/models/filter.model'

interface KeyOptions {
  page: number
  filterQueries?: FilterGroup[]
  tag?: string
  searchTerm?: string
  sort?: Sort
  categoryTag?: string
}

export function getRequestKey(options: KeyOptions) {
  const { searchTerm, page, tag: startTag, sort } = options

  let tag = startTag || 'req'

  if (options.categoryTag)
    tag = tag.concat(`_category-${options.categoryTag}`)

  if (searchTerm)
    tag = tag.concat(`_search-${searchTerm}`)

  if (sort)
    tag = tag.concat(`_sort-${sort}`)

  if (options.filterQueries) {
    const filterString = options.filterQueries
      .map((filter) => {
        return getQueryString(filter)
      })
      .flat()
      .join('_')

    tag = tag.concat(`_filters-${filterString}`)
  }

  tag = tag.concat(`_page-${page}`)

  return tag
}
